export default function getPathFromSVG(inSvgString) {
    const parser = new DOMParser();
    const svgDoc = parser.parseFromString(inSvgString, 'image/svg+xml');
    const pathElement = svgDoc.querySelector('path');
    return pathElement ? pathElement.getAttribute('d') : null;
}